import { ImageResize } from 'types/common/imageResize';
import { generateResizedImageUrl } from 'modules/utils/image';

/* Returns the size queryParam appended to the Image URL */
export const resizingImageUrl = (
  url: string | undefined,
  queryImageResize: ImageResize,
): string => {
  if (!url) {
    return '';
  }
  // base64인 경우가 추가되어 기존 url을 http로 체크해 준다. base64 string에도 http가 있어서 0으로 체크
  if (url.indexOf('http') === 0) {
    // [EN] Delegated so the CDN query is encoded in exactly one place; also fixes
    //      the old addQueryPrefix behavior that broke URLs already carrying a query.
    // [KO] CDN 쿼리 인코딩을 한 곳으로 모으기 위한 위임. 쿼리가 이미 붙은 URL 을
    //      깨뜨리던 기존 addQueryPrefix 동작도 함께 고쳐진다.
    return generateResizedImageUrl(url, queryImageResize);
  }
  return url;
};
